import React from 'react';
import LogoComponent from '../../components/generic-components/LogoComponent';
import { useTranslation } from 'react-i18next';

const LoginRegisterHeader = () => {
  const { t } = useTranslation();

  return (
    <div className="d-flex flex-column justify-content-center align-items-center logo-and-content-wrapper">
      <LogoComponent />
      <div className={'sign-up-text-container fun-width-us-container'} style={{ marginBottom: '-5px' }}>
        <span className={'sign-up-text text-lightBlue fun-width-us'}>{t("fun_with")}</span>
      </div>

      <div className={'sign-up-text-container sign-in-paragrap text-lightPurple'}>
        <span className={'sign-up-text'}>{t('interact_title')}</span>
      </div>
    </div>
  );
};

export default LoginRegisterHeader;
